import axios, {
  AxiosInstance,
  AxiosResponse,
  InternalAxiosRequestConfig,
} from "axios";
import { postTrackingLogger } from "./offers/offers.service";

// Helper function to get cookie value by name
const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

// Helper function to get item from sessionStorage, localStorage, or cookies (in that order)
const getStorageItem = (key: string): string | null => {
  // First check sessionStorage
  let value = sessionStorage.getItem(key);
  if (value) return value;

  // Then check localStorage
  value = localStorage.getItem(key);
  if (value) return value;

  // Finally check cookies
  value = getCookie(key);
  return value;
};

// default axios config
export const apiConfigTagApi: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_TAGAPI_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// default axios config
export const apiConfigAppApi: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// default axios config
export const apiConfigTrackingApi: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_TRACKAPI_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

const intercaptorRequest = (config: InternalAxiosRequestConfig) => {
  const myUniqueId = getStorageItem("brswUserSessionId");
  config.headers["usersessionid"] = "not-set";
  if (myUniqueId) {
    config.headers["usersessionid"] = myUniqueId;
  } else {
    if (config.url !== "/tracking/logger") {
      postTrackingLogger({
        message: `User session ID not set in request. Data: ${JSON.stringify(
          config.data
        )}`,
        companyId: "",
        placementId: "",
        campaignId: "",
        templateId: "",
        layoutId: "",
        page: config.url || "",
      });
    }
  }

  return config;
};

const interceptorResponse = (config: AxiosResponse) => {
  return config;
};
const interceptorResponseError = async (error: any) => {
  if (error?.response) {
    return error.response;
  }
  return Promise.reject(error);
};

apiConfigTagApi.interceptors.request.use(intercaptorRequest);
apiConfigTagApi.interceptors.response.use(
  interceptorResponse,
  interceptorResponseError
);

apiConfigTrackingApi.interceptors.request.use(intercaptorRequest);
apiConfigTrackingApi.interceptors.response.use(
  interceptorResponse,
  interceptorResponseError
);

export default apiConfigTagApi;
